import { CardTabsLink as CardTabsLinkComponent } from "./CardTabsLink.component";

export const CardTabsLink = CardTabsLinkComponent;
